import { defineMessages } from 'react-intl';

import { DiscordAccount } from '../DiscordAccount';
import { SettingsSection } from '../SettingsSection';
import { TwitterAccount } from '../TwitterAccount';

const messages = defineMessages({
  title: {
    id: 'Settings.connectedAccounts.socials',
    defaultMessage: 'Socials',
  },
});

export const SocialAccounts = () => {
  return (
    <SettingsSection {...messages}>
      <TwitterAccount />
      <DiscordAccount />
    </SettingsSection>
  );
};
